import React, { useState } from 'react';

const BikeTime = ({ callback }) => {
    const [speed, setSpeed] = useState('30.0');
    const [unit, setUnit] = useState('kph');

    const updateSpeed = value => {
        setSpeed(value);
        recalculate(value, unit);
    }

    const updateUnit = value => {
        setUnit(value);
        recalculate(speed, value);
    }

    const recalculate = (speed, unit) => {
        const speedNum = Number(speed);

        if (speed !== '' && speedNum > 0) {
            const seconds = ((60 / speedNum) * 60);
            const adjustedSeconds = (unit === 'kph') ? seconds : (seconds / 1.6);
            callback('bike', adjustedSeconds);
        }
    }

    return (
        <div>
            <h2>Bike time</h2>
            <label>
                <p>Enter your average speed over the bike course</p>
                <input
                    type="number"
                    step="0.1"
                    value={speed}
                    onChange={event => updateSpeed(event.target.value)}
                />
            </label>
            <select value={unit} onChange={event => updateUnit(event.target.value)} ariaLabel="Unit">
                <option value="kph">km/h</option>
                <option value="mph">mi/h</option>
            </select>
        </div>
    );
};

export default BikeTime;
